import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWildcard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 60,
	viewBox: "0 0 64 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M40.735 57.74H23.105C17.965 57.74 13.795 53.57 13.795 48.43V11.23C13.795 6.28001 17.815 2.26001 22.765 2.26001H41.705C46.395 2.26001 50.205 6.07001 50.205 10.76V48.27C50.205 53.5 45.965 57.74 40.735 57.74Z",
			fill: "#3A305C",
			stroke: "#3A305C",
			strokeWidth: 4,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.285 56.25H41.905C46.003 56.25 49.325 52.9279 49.325 48.83V11.16C49.325 7.06199 46.003 3.73999 41.905 3.73999H22.285C18.1871 3.73999 14.865 7.06199 14.865 11.16V48.83C14.865 52.9279 18.1871 56.25 22.285 56.25Z",
			fill: "#3A305C",
			stroke: "white",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.335 29.18L35.955 26.38C36.905 25.65 37.995 24.84 38.045 23.73C38.115 22.15 38.125 20.61 38.015 19.09L33.515 19.01L35.765 16.78L39.865 12.74C40.355 13.1 40.695 13.5 41.075 13.87L41.145 13.93L46.335 19.01L41.745 19.04L41.695 23.72C41.655 27.08 37.355 28.95 35.625 30.58L34.945 31.22",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.0451 47.19L41.7551 47.25C41.7551 47.25 41.7751 43.96 41.7251 43.96L41.6951 39.19C41.6851 37.55 40.5451 36.14 39.0851 35L34.6351 31.54L32.7951 30.09L31.9551 29.43L27.0151 25.53C26.4351 25.07 25.9451 24.4 25.9351 23.74L25.9151 19.06L30.4651 19.03L25.3251 13.96C24.9251 13.57 24.5451 13.16 24.0651 12.76L20.0251 16.73L19.9551 16.79L17.7051 19.02L22.2051 19.1L22.3151 23.97C22.3651 26.26 24.6651 27.69 26.2651 28.98L28.1651 30.51C28.5951 30.86 29.0251 31.13 29.4151 31.44L30.2351 32.09C30.8151 32.55 31.3851 33.02 31.9451 33.5L32.0251 33.57C32.4651 33.95 32.9951 34.27 33.5051 34.66L36.2951 36.83C37.1951 37.53 38.0451 38.31 38.0851 39.35C38.1351 40.89 38.2051 45.7 38.0851 47.19L38.1451 42.82",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.175 47.2198L25.8951 47.2598L25.9151 39.2598C25.9151 38.4498 26.555 37.6998 27.295 37.1398L31.625 33.8198",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.0951 31.71L24.1151 35.66C22.9851 36.56 22.3051 37.76 22.2751 39.01L22.175 47.2099",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgWildcard;
